module.exports = __webpack_public_path__ + "static/ms-partner-animated-d230167acda29843b148d362ea9516d9.gif";